import { useRouter, useRouterState } from "@tanstack/react-router";
import { useI18n } from "@/lib/i18n";
import { translatePortuguese } from "@/data/portuguese-core";

/** A small floating "back" control, shown on every page except the home page. */
export function BackButton() {
  const router = useRouter();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const { lang } = useI18n();
  const corePortuguese = lang === "pt" && ["/about", "/contact"].includes(pathname);

  if (pathname === "/") return null;

  return (
    <button
      type="button"
      onClick={() => {
        if (typeof window !== "undefined" && window.history.length > 1) router.history.back();
        else router.navigate({ to: "/" });
      }}
      aria-label={translatePortuguese("Go back", corePortuguese ? "pt" : "en")}
      className="fixed bottom-6 left-4 z-50 flex items-center gap-2 bg-ink/40 px-3 py-2 font-mono text-[9px] uppercase tracking-[0.3em] text-bone/60 backdrop-blur-md transition-colors hover:text-bone md:bottom-8 md:left-[3vw]"
    >
      <span aria-hidden="true" className="text-[11px] leading-none">
        ←
      </span>
      {translatePortuguese("Back", corePortuguese ? "pt" : "en")}
    </button>
  );
}
